<div class="k-d-grid k-gap-y-xl">

    <div *ngIf="!studentsSelected">
        <h5 class="subsection__subheading">Mandate and Assignment Comparison</h5>
        <kendo-grid [kendoGridBinding]="compareMandatesGridView" [pageSize]="10"
            [pageable]="{ pageSizes: [5, 10, 20] }" class="mandate-grid">
            <kendo-grid-command-column [width]="62" [locked]="true">
                <ng-template kendoGridCellTemplate let-dataItem let-index="rowIndex">
                    <button kendoButton kendoGridRemoveCommand [svgIcon]="xMark" themeColor="light"
                        (click)="removeMandate(index)" aria-label="Remove mandate"></button>
                </ng-template>
            </kendo-grid-command-column>

            <kendo-grid-column-group title="Student Information" [locked]="true">
                <kendo-grid-column field="student" title="Student" [width]="255">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <strong><span>{{dataItem?.studentDetails?.studentName}}</span> <span>(ID:
                                {{dataItem?.studentDetails?.nycId}})</span></strong>
                        <p class="!k-my-0 k-text-wrap">
                            <span class="secondary" *ngIf="dataItem?.studentDetails?.dob">DOB:
                                {{dataItem?.studentDetails?.dob | formatDate}}</span><span class="secondary"
                                *ngIf="dataItem?.studentDetails?.grade"> |
                                Grade:
                                {{dataItem.studentDetails?.dataItem?.grade}}</span>
                        </p>
                        <p class="!k-my-0 k-text-wrap">
                            <span class="secondary" *ngIf="dataItem?.studentDetails?.disability"> | Disability:
                                {{dataItem?.studentDetails?.disability}}</span>
                        </p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="physLoc" title="Phys Loc" [width]="94">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.studentDetails?.physicalLocation}}</p>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid-column-group>

            <kendo-grid-column-group title="IEP Information">
                <kendo-grid-column field="serviceType" title="Service Type" [width]="220">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.mandateDetails?.serviceType}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="language" title="Language" [width]="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.mandateDetails?.language}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="frequencyIep" title="Frequency" [width]="104">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.mandateDetails?.frequency}}{{ dataItem?.mandateDetails?.period }}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="durationIep" title="Duration" [width]="91">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.mandateDetails?.duration}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="groupSizeIep" title="Group Size" [width]="106">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.mandateDetails?.groupSize}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="locationIep" title="Location" [width]="255">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.mandateDetails?.location}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="serviceDatesIep" title="Service Dates" [width]="250">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{getDateRangeDisplay(dataItem?.mandateDetails?.serviceDate)}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="termIep" title="Term" [width]="67">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{dataItem?.mandateDetails?.term}}</p>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid-column-group>

            <kendo-grid-column-group title="Assignment Information">
                <kendo-grid-column field="assignmentDates" title="Dates" [width]="250">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <p>{{getDateRangeDisplay(dataItem?.assignmentDetails?.dates)}}</p>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="frequencyAssignment" title="Frequency" [width]="104">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="cell-with-warning">
                        <p *ngIf="dataItem?.assignmentDetails?.frequency">
                            {{ dataItem.assignmentDetails.frequency }}
                            {{ dataItem?.mandateDetails?.period }}
                        </p>

                        <span
                            *ngIf="
                            dataItem?.assignmentDetails?.frequency &&
                            dataItem?.mandateDetails?.mandateStatus === 'Partially Assigned'
                            "
                            kendoTooltip
                            tooltipClass="warning-tooltip"
                            title="Partial"
                            position="bottom"
                        >
                            <fa-icon icon="exclamation-circle" class="warning-icon"></fa-icon>
                        </span>
                        </div>
                    </ng-template>
                    </kendo-grid-column>

                <kendo-grid-column field="durationAssignment" title="Duration" [width]="91">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="cell-with-warning">
                    <p
                        *ngIf="
                        dataItem?.assignmentDetails?.duration !== null &&
                        dataItem?.assignmentDetails?.duration !== undefined
                        "
                    >
                        {{ dataItem.assignmentDetails.duration }}
                        <!-- <span *ngIf="dataItem.assignmentDetails.duration !== 0">%</span> -->
                    </p>

                    <span
                        *ngIf="
                        dataItem?.assignmentDetails?.duration !== null &&
                        dataItem?.assignmentDetails?.duration !== undefined &&
                        dataItem?.mandateDetails?.mandateStatus === 'Partially Assigned'
                        "
                        kendoTooltip
                        tooltipClass="warning-tooltip"
                        title="Partial"
                        position="bottom"
                    >
                        <fa-icon icon="exclamation-circle" class="warning-icon"></fa-icon>
                    </span>
                    </div>
                </ng-template>
                </kendo-grid-column>

            </kendo-grid-column-group>

            <!-- <kendo-grid-column-group title="Total Sessions">
            <kendo-grid-column field="totalNeeded" title="Needed" [width]="85">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <p>{{dataItem?.totalSessionDetails?.needed}}</p>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="totalScheduled" title="Scheduled" [width]="105">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <p>{{dataItem?.totalSessionDetails?.scheduled}}</p>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="totalToBeScheduled" title="To be Scheduled" [width]="145">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <p>{{dataItem?.totalSessionDetails?.toBeScheduled}}</p>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid-column-group> -->
        </kendo-grid>
        <span class="k-form-separator !k-my-10"></span>

    </div>


    <div *ngIf="!studentsSelected">
        <h5 class="subsection__subheading">Annual Goals</h5>
        <kendo-grid [kendoGridBinding]="annualGoalsGridView" [pageSize]="10" [pageable]="{ pageSizes: [5, 10, 20] }"
            [resizable]="true">
            <kendo-grid-command-column [width]="62">
                <ng-template kendoGridCellTemplate let-dataItem let-index="rowIndex">
                    <button kendoButton kendoGridRemoveCommand [svgIcon]="xMark" themeColor="light"
                        (click)="removeAnnualGoals(index)" aria-label="Remove annual goal"></button>
                </ng-template>
            </kendo-grid-command-column>
            <kendo-grid-column field="student" title="Student" [width]="255">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <strong> <span
                            *ngIf="dataItem?.studentDetails?.studentName">{{dataItem?.studentDetails?.studentName}}</span>
                        <span *ngIf="dataItem?.studentDetails?.nycId">(ID:
                            {{dataItem?.studentDetails?.nycId}})</span></strong>
                    <p class="!k-my-0">
                        <span class="secondary" *ngIf="dataItem?.studentDetails?.dob">DOB:
                            {{dataItem?.studentDetails?.dob | formatDate}}</span><span class="secondary"
                            *ngIf="dataItem?.studentDetails?.grade"> |
                            Grade:
                            {{dataItem.studentDetails?.grade}}</span>
                    </p>
                    <p class="!k-my-0">
                        <span class="secondary" *ngIf="dataItem?.studentDetails?.disability"> | Disability:
                            {{dataItem?.studentDetails?.disability}}</span>
                    </p>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="annualGoals" title="Annual Goals" [width]="550">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <ol>
                        <li *ngFor="let goal of dataItem?.anualGoals" style="text-wrap:auto">{{goal}}</li>
                    </ol>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <!-- <span class="k-form-separator !k-my-10"></span> -->

    <ng-container>
        <h5 class="subsection__subheading">Schedules</h5>
        <form [formGroup]="schedulesFormGroup">
            <div class="k-d-flex k-gap-xl k-align-items-center">
                <kendo-svg-icon [icon]="clock" size="medium"></kendo-svg-icon>
                <div class="k-d-flex k-gap-x-sm k-align-items-center">
                    <kendo-formfield [style.width.px]="160">
                        <kendo-label text="Start Date" labelCssClass="hidden-label">
                            <kendo-datepicker calendarType="classic" placeholder="Start Date"
                                formControlName="startDate"></kendo-datepicker>
                        </kendo-label>
                    </kendo-formfield>
                    <kendo-formfield [style.width.px]="140">
                        <kendo-label text="Start Time" labelCssClass="hidden-label">
                            <kendo-timepicker placeholder="Start Time" formControlName="startTime"></kendo-timepicker>
                        </kendo-label>
                    </kendo-formfield>
                    <span class="k-d-flex k-align-items-center">to</span>
                    <!-- <kendo-formfield [style.width.px]="160">
                        <kendo-label text="End Date" labelCssClass="hidden-label">
                            <kendo-datepicker calendarType="classic" placeholder="End Date"
                                formControlName="endDate"></kendo-datepicker>
                        </kendo-label>
                    </kendo-formfield> -->
                    <kendo-formfield [style.width.px]="140">
                        <kendo-label text="End Time" labelCssClass="hidden-label">
                            <kendo-timepicker placeholder="End Time" formControlName="endTime"></kendo-timepicker>
                        </kendo-label>
                    </kendo-formfield>
                    <span>{{duration}}</span>
                </div>
            </div>
        </form>
        <div style="width: 83vw;">
            <app-schedules-timeline [schedulesFormGroup]="schedulesFormGroup"
                [selecteStudentdMandates]="selecteStudentdMandates"
                 [compareMandatesGridView]="compareMandatesGridView"
                [studentsSelected]="studentsSelected" [selectedMandates]="selectedMandates"
                [isEditingSession]="isEditingSession" [editStartTime]="editStartTime"
                [editStartDate]="editStartDate" [studentSk]="studentSk" 
                [editSelectedMandates]="editSelectedMandates"></app-schedules-timeline>
        </div>
    </ng-container>
</div>